<template>
    <app-outline-main>
        <template #fixed-top>
            <app-filter-group
                class="gutter-bottom"
                @query="handQuery"
                @reset="handleResetPageParams">
                <gj-country-server-select
                    v-model="pageParams.countryData"
                ></gj-country-server-select>
                <gj-select-date-picker
                    v-model="pageParams.date"
                    :type="pageParams.date.key === 'DAY' ? 'daterange' : 'monthrange'"
                    :shortcut="pageParams.date.key === 'DAY'"
                    :shortcuts="['今天', '昨天', '近7天', '近14天', '近30天', '本月', '上月', '本年至今']"
                    :options="pageEnums.DATE_TYPE_OPTIONS"
                    :format="pageParams.date.key === 'DAY' ? 'yyyy-MM-dd' : 'yyyy-MM'"
                    :value-format="pageParams.date.key === 'DAY' ? 'yyyy-MM-dd' : 'yyyy-MM'"
                    :deafault-value="[new Date(), new Date()]"
                    :dateClearable="false"
                    @prefix-change="changeDateType"
                >
                </gj-select-date-picker>
                <el-col>
                  <gj-select
                      class="asin-select"
                      v-model="pageParams.asinType"
                      :options="pageEnums.ASIN_OPTIONS"
                      :clearable="false">
                  </gj-select>
                    <el-autocomplete
                        v-model="pageParams.asinCode"
                        :fetch-suggestions="querySearch"
                        :trigger-on-focus="false"
                        :debounce="500"
                        style="height: 32px"
                        placeholder=""
                        size="mini"
                        @select="handleSelect"
                    ></el-autocomplete>
                </el-col>

                <template #right>
                  <gj-tool-group help></gj-tool-group>
                    <ViewSettingComponent
                            :ref="REF_VIEW_SETTING"
                            save-mode="remote"
                            :use-default="true"
                            :module-name="moduleName"
                            :config="model"
                            :fn-generate-params="generateViewParams"
                            @view-change="handleChangeView"
                            @view-complete="handCompleteView"
                    >
                        <template v-slot:dateRange="{ formData }">
                            <gj-select
                                    style="width: 130px"
                                    v-model="formData.dateType"
                                    :options="pageEnums.DATE_TYPE_OPTIONS"
                                    :clearable="false"
                                    @change="() => formData.dateRange = 0"
                            ></gj-select>
                            <gj-select
                                    style="margin-left: 8px;width: 130px;"
                                    v-model="formData.dateRange"
                                    :options="formData.dateType === 'DAY' ? pageEnums.timeRangeOptions : pageEnums.monthRangeOptions"/>
                        </template>
                        <template v-slot:asinCode="{ formData }">
                            <gj-select v-model="formData.asinType" :options="pageEnums.ASIN_OPTIONS"></gj-select>
                            <el-select  class="asin-search"
                                        v-model="formData.asinCode"
                                        size="small"
                                        filterable
                                        remote
                                        reserve-keyword
                                        :remote-method="debounceFetchAsin"
                                        style="margin-left: 8px;"
                            >
                                <el-option v-for="asin in asinList" :key="asin.id" :label="asin.text" :value="asin.id"></el-option>
                            </el-select>
                        </template>
                    </ViewSettingComponent>
                </template>
            </app-filter-group>
        </template>
        <div v-if="canRequest" class="main-content">
            <BaseInfo ref="baseInfo"/>
            <app-outline-content label="综合分析">
                <vue-lazy-component :viewport="root">
                    <ComprehensiveAnalysis ref="comprehensiveAnalysis" class="option-analysis" />
                    <OptionCard :info="{ title: '综合分析' }" slot="skeleton" class="option-analysis" v-loading="true">
                        <div style="height: 577px" ></div>
                    </OptionCard>
                </vue-lazy-component>
            </app-outline-content>
            <app-outline-content label="销售分析">
                <vue-lazy-component :viewport="root">
                    <SaleAnalysis ref="saleAnalysis" class="option-analysis"/>
                    <OptionCard :info="{ title: '销售分析' }" slot="skeleton" class="option-analysis" v-loading="true">
                        <div style="height: 1884px;" ></div>
                    </OptionCard>
                </vue-lazy-component>
            </app-outline-content>
            <app-outline-content label="广告分析">
                <vue-lazy-component :viewport="root">
                    <AdAnalysis ref="adAnalysis" class="option-analysis"/>
                    <OptionCard :info="{ title: '广告分析' }" slot="skeleton" class="option-analysis" v-loading="true">
                        <div style="height: 1884px;"></div>
                    </OptionCard>
                </vue-lazy-component>
            </app-outline-content>
            <app-outline-content label="费用利润">
                <vue-lazy-component :viewport="root">
                    <PurchaseAnalysis ref="purchaseAnalysis" class="option-analysis"/>
                    <OptionCard :info="{ title: '费用利润' }" slot="skeleton" class="option-analysis" v-loading="true">
                        <div  style="height: 926px;" ></div>
                    </OptionCard>
                </vue-lazy-component>
            </app-outline-content>
            <app-outline-content label="库存分析">
                <vue-lazy-component :viewport="root">
                    <StockAnalysis ref="stockAnalysis" class="option-analysis"/>
                    <OptionCard :info="{ title: '库存分析' }" slot="skeleton" class="option-analysis" v-loading="true">
                        <div  style="height: 1164px;"></div>
                    </OptionCard>
                </vue-lazy-component>
            </app-outline-content>
            <app-outline-content label="买家评论">
                <vue-lazy-component :viewport="root">
                    <ReviewAnalysis ref="reviewAnalysis" class="option-analysis"/>
                    <OptionCard :info="{ title: 'Review分析' }" slot="skeleton" class="option-analysis" v-loading="true">
                        <div  style="height: 1657px;"></div>
                    </OptionCard>
                </vue-lazy-component>
            </app-outline-content>
            <app-outline-content label="关键词排名">
                <vue-lazy-component :viewport="root">
                    <KeywordAnalysis ref="keywordAnalysis" class="option-analysis"/>
                    <OptionCard :info="{ title: '关键词排名' }" slot="skeleton" class="option-analysis" v-loading="true">
                        <div  style="height: 712px;"></div>
                    </OptionCard>
                </vue-lazy-component>
            </app-outline-content>
        </div>
        <div v-else class="asin-content ">
            <div class="asin-content-no-content">
                <gj-empty text="请先输入查询参数后查询"></gj-empty>
            </div>
        </div>
    </app-outline-main>
</template>

<script>
    import { getAsinList } from '@/api/statistics'

    import {
        ASIN_ENUMS
    } from "modules/statistics/asin-361-analysis/config"
    import {
        DATE_TYPE_OPTIONS,
        ASIN_OPTIONS,
        timeRangeOptions,
        monthRangeOptions
    } from '@/utils/options'
    import {
        ASIN_361_MODULE,
    } from "@/utils/const";
    import { VIEW_ASIN_361_SETTING } from './config'
    import _ from 'lodash'
    import {
        convertToMonth,
        convertToDate,
        dateShortcut
    } from "@/utils/date.util";
    import { subDays, startOfWeek, endOfWeek, startOfMonth, endOfMonth, startOfYear } from 'date-fns'
    import { debounce } from 'lodash'
     import {convertToFullDate} from "@/utils/date.util";
    import ViewSettingComponent from 'components/view-setting/view-setting'
    import BaseInfo from './components/base-info'
    import ComprehensiveAnalysis from './components/comprehensive-analysis'
    import SaleAnalysis from './components/sale-analysis'
    import AdAnalysis from './components/ad-analysis'
    import PurchaseAnalysis from './components/purchase-analysis'
    import ReviewAnalysis from './components/review-analysis'
    import StockAnalysis from './components/stock-analysis/index.vue'
    import KeywordAnalysis from './components/keyword-analysis'
    import OptionCard from 'components/option-card/option-card'
    import {isMeaningful} from "@/utils/common";
    import {queryMixin} from "@/minxins";

    export default {
        name: "asin-361-analysis",
        mixins: [queryMixin],
        components:{
            BaseInfo,
            ComprehensiveAnalysis,
            SaleAnalysis,
            AdAnalysis,
            PurchaseAnalysis,
            ReviewAnalysis,
            StockAnalysis,
            KeywordAnalysis,
            OptionCard,
            ViewSettingComponent
        },
        provide() {
            return {
                getPageParams: () => this.pageParams,
                generatorPageParams: this.generatorPageParams
            }
        },
        data() {
            return {
                pageEnums: {
                    DATE_TYPE_OPTIONS,
                    ASIN_OPTIONS,
                    ASIN_ENUMS,
                    timeRangeOptions,
                    monthRangeOptions
                },
                pageParams: {
                    countryData: {
                        countryIds: [], // 国家
                        marketIds: [], // 店铺
                    },
                    date: { // 日期范围
                        key: 'DAY',
                        value: null
                    },
                    asinType: 'child',
                    asinCode: '',
                    startDateTime: '', // 开始日期
                    endDateTime: '', // 结束日期
                    dateLabel: ''
                },
                defaultDate: [convertToFullDate(subDays(new Date(), 13), 'yyyy-MM-dd'), convertToFullDate(new Date(), 'yyyy-MM-dd')],
                asinList: [],
                canRequest: false,
                root: document.querySelector('.main-content'),
                debounceFetchAsin: debounce(this.getAsinLists, 100),
                moduleName: ASIN_361_MODULE,
                model: VIEW_ASIN_361_SETTING,
                REF_VIEW_SETTING: 'viewSetting',
                cacheOptions: {
                    filterKey: 'pageParams'
                },
                isUseCache: true
            }
        },
        created () {

        },
        computed: {
            CACHE_PARAMS () {
                return this.pageParams
            }
        },
        methods:{
        async querySearch(queryString,cb){
             let list = [];
             list = await this.getAsinLists(queryString);
             let results = list.length > 0 ? list : [];
             cb(results);
          },
          handleSelect(item){
            this.pageParams.asinCode = item.id;
          },
            selectFocus(e) {
                let value = e.target.value;
                setTimeout(() => {
                   let input = this.$refs.elSelect.$children[0].$refs.input;
                   input.value = value;
               })
            },
            visibleChange(val) {
                if(!val){
                 let input = this.$refs.elSelect.$children[0].$refs.input;
                 input.blur();
               }
            },
            /**
             * 初始化路由参数
             */
            initParams () {
                let { params } = this.$route.query
                if (params) {
                    try {
                        params = JSON.parse(params)
                        const pageParams = this.pageParams
                        this.pageParams.asinType = params.asinType ? params.asinType : pageParams.asinType
                        this.pageParams.asinCode = params.asinCode ? params.asinCode : pageParams.asinCode
                        this.pageParams.date.key = params.date.type ? params.date.type : pageParams.date.key
                        this.pageParams.date.value = params.date.value && params.date.value.length ? params.date.value : this.defaultDate
                        this.pageParams.countryData = params.countryData ? params.countryData : pageParams.countryData
                    } catch (e) {
                        console.warn(e)
                    }
                }
            },
            /**
             * 设置全局查询参数
             */
            mergeRemoteParams (params) {
                let {
                    countryData,
                    dateType: key = 'DAY',
                    startDateTime = '',
                    endDateTime = '',
                    asinType = 'parent',
                    asinCode = '',
                } = params

                countryData = countryData || {}
                const {
                    countryIds = [],
                    marketIds = [],
                } = countryData

                this.pageParams = {
                    countryData: {
                        countryIds, // 国家
                        marketIds, // 店铺
                    },
                    date: { // 日期范围
                        key,
                        value: [startDateTime || convertToDate(new Date()), endDateTime || convertToDate(new Date())]
                    },
                    asinType,
                    asinCode,
                    startDateTime, // 开始日期
                    endDateTime // 结束日期
                }
            },
            /**
             * 获取asin列表
             */
           getAsinLists(query) {
                let params = this.generatorPageParams(this.pageParams)
                params.asinCode = query
                return getAsinList(params).then((res = []) => {
                    this.asinList = res;
                    res.forEach(item=>{
                      item.label = item.test;
                      item.value = item.id;
                    })
                    return res;
                })
            },
            /**
             *
             * @param params 查询条件参数
             * @override queryMixin
             * @returns {{ countryData: *}}
             */
            $gjCacheCallback(params) {
                return {
                    countryData: params.countryData
                };
            },
            handQuery() {
                if (!this.pageParams.asinCode) {
                    this.$gjMessage.warning('请输入ASIN后查询')
                    return
                }
                this.setCacheData()
                this.handleFetchPage()
            },
            /**
             * 查询页面数据
             */
            handleFetchPage () {
                const refsInstance = this.$refs
                if (!this.pageParams.asinCode) {
                    this.$gjMessage.warning('请输入ASIN后查询')
                    return
                }

                // const query = this.$route.query
                // if (!query || JSON.stringify(query) == '{}') {
                //     this.setCacheData()
                // }
                this.canRequest = true
                Object.values(refsInstance).forEach(v => {
                    v && v.refresh && v.refresh()
                })

                // this.handleSaveCurrentView()
            },
            /**
             * 重置查询条件
             */
            handleResetPageParams () {
                this.pageParams = Object.assign({}, this.pageParams, {
                    countryData: {
                        countryIds: [], // 国家
                        marketIds: [], // 店铺
                    },
                    date: { // 日期范围
                        key: 'DAY',
                        value: this.defaultDate
                    }
                })
                this.$gjCacheReset()
                // this.handleFetchPage()
            },
            /**
             * 按入参格式化输出pageParams
             */
            generatorPageParams (params) {
                params = _.cloneDeep(params)
                params.date.value = params.date.value && params.date.value.length ? params.date.value : this.defaultDate
                params.startDateTime = params.date.value && params.date.value.length ? params.date.value[0] : ''
                params.endDateTime = params.date.value && params.date.value.length ? params.date.value[1] : ''
                return {
                    marketIds: params.countryData.marketIds,
                    countryCodes: params.countryData.countryIds,
                    asinType: params.asinType,
                    asinCode: params.asinCode,
                    dateRangeType: params.date.key,
                    startDateTime: params.date.key === 'MONTH' ? convertToMonth(new Date(params.startDateTime)) : convertToDate(new Date(params.startDateTime)),
                    endDateTime: params.date.key === 'MONTH' ? convertToMonth(new Date(params.endDateTime)) : convertToDate(new Date(params.endDateTime)),
                }
            },
            /**
             * 保存视图
             */
            handleSaveCurrentView () {
                let pageParams = this.pageParams
                const currentView = this.$refs.viewSetting.view
                if (currentView) {
                    const formData = {
                        id: currentView.id,
                        name: currentView.name,
                        countryServer: {
                            countryIds: pageParams.countryData.countryIds,
                            marketIds: pageParams.countryData.marketIds,
                        },
                        dateType: pageParams.date.key,
                        startDateTime: pageParams.date.value ? (pageParams.date.value[0] || '') : '',
                        endDateTime: pageParams.date.value ? (pageParams.date.value[1] || '') : '',
                        asinType: pageParams.asinType,
                        asinCode: pageParams.asinCode,
                    }
                    let params = {
                        params: JSON.stringify(formData),
                        module: ASIN_361_MODULE,
                        name: formData.name,
                        id: currentView.id || ''
                    }

                    this.$refs.viewSetting.putEditView(params)
                }
            },

            handCompleteView(view) {
                let params = {}
                let cacheData = this.getCacheData() || {}
                const { query = {} } = this.$route
                if (!this._.isEmpty(query)) {
                    params = query
                    this.initParams()
                    this.setCacheData()
                } else {
                    if (cacheData.query && JSON.stringify(cacheData.query) !== '{}') {
                        params = cacheData.query
                    } else if (view && view.params) {
                        params = JSON.parse(view.params)
                    } else {
                        params.startDateTime = convertToFullDate(subDays(new Date(), 13), 'yyyy-MM-dd')
                        params.endDateTime = convertToFullDate(new Date(), 'yyyy-MM-dd')
                    }
                    this.mergeRemoteParams(params)
                }
                this.handleFetchPage()
                // if (view && view.params) {
                //     try {
                //         let params = JSON.parse(view.params)
                //         if (params) {
                //             this.mergeRemoteParams(params)
                //             this.handleFetchPage()
                //         }
                //     } catch (e) {
                //         console.warn(e)
                //     }
                // } else {
                //     this.handleResetPageParams()
                // }
            },
            /**
             * 切换视图
             */
            async handleChangeView (view) {
                if (view && view.params) {
                    try {
                        let params = JSON.parse(view.params)
                        if (params) {
                            this.mergeRemoteParams(params)
                            this.handleFetchPage()
                        }
                    } catch (e) {
                        console.warn(e)
                    }
                } else {
                    this.handleResetPageParams()
                }
            },
            customHandView() {
                this.initParams()

                const query = this.$route.query
                const params = this.getCacheData() || {}
                if (params.query && JSON.stringify(query) == '{}' ) {
                    this.mergeRemoteParams(params.query)
                }
                this.$nextTick(() => {
                    this.canRequest = !!this.pageParams.asinCode && !!this.pageParams?.date?.value?.length
                })
            },
            loadViewComplete () {

            },
            /**
             * 构造视图参数
             */
            generateViewParams (params) {
                let [ startDateTime = '', endDateTime = '' ] = this.generatorTrulyDateTime(params.dateType, params.dateRange)
                params.startDateTime = params.dateType === 'DAY' ? convertToDate(startDateTime) : convertToMonth(startDateTime)
                params.endDateTime = params.dateType === 'DAY' ? convertToDate(endDateTime) : convertToMonth(endDateTime)
                return Promise.resolve(params)
            },
            /**
             * 处理选中时间
             * @param dateType 选择时间范围的类型
             * @param dateRange 时间范围
             */
            generatorTrulyDateTime (dateType = 'DAY', dateRange = 0) {
                return dateType === 'DAY' ? this.generatorDate(dateRange) : this.generatorMonth(dateRange)
            },
            /**
             * 处理选中月份
             * @param dateRange 选择值
             * @returns {{startDateTime: string, endDateTime: string}|Date[]}
             */
            generatorMonth (dateRange) {
                if (!isMeaningful(dateRange)) return ['', '']
                let end = new Date()
                let start = new Date()
                switch (dateRange) {
                    case 1:
                        start.setMonth(start.getMonth() - 1)
                        end.setMonth(end.getMonth() - 1)
                        break;
                    case 2:
                        start.setMonth(start.getMonth() - 2)
                        break
                    case 3:
                        start.setMonth(start.getMonth() - 6)
                        break
                    case 4:
                        start = new Date(start.getFullYear(), 0)
                        break
                }
                return [start, end]
            },
            /**
             * 处理选中日期范围
             * @param dateRange 选中值
             * @returns {{startDateTime: string, endDateTime: string}|Date[]}
             */
            generatorDate (dateRange) {
                if (!isMeaningful(dateRange)) return ['', '']
                let end = new Date()
                let start = new Date()
                switch (dateRange) {
                    case 1:
                        start = subDays(start, 1)
                        break;
                    case 2:
                        start = subDays(start, 6)
                        break
                    case 3:
                        start = subDays(start, 13)
                        break
                    case 4:
                        start = subDays(start, 29)
                        break
                    case 5:
                        start = subDays(start, 59)
                        break
                    case 6:
                        start = startOfWeek(start)
                        end = endOfWeek(end)
                        break
                    case 7:
                        start = startOfMonth(start)
                        end = endOfMonth(end)
                        break
                    case 8:
                        start = startOfYear(start)
                        break
                }

                return [start, end]
            },
            changeDateType (value) {
                this.pageParams.date.value = value.key === 'MONTH' ? [convertToMonth(new Date(value.value[0])), convertToMonth(new Date(value.value[1]))] : [convertToDate(new Date(value.value[0])), convertToDate(new Date(value.value[1]))]
            }
        },
        watch: {
            'pageParams.date': {
                deep: true,
                immediate: true,
                handler(value) {
                    if (value) {
                        value = value.value || []
                        this.pageParams.startDateTime = value[0] || ''
                        this.pageParams.endDateTime = value[1] || ''
                        this.pageParams.dateLabel = dateShortcut([new Date(this.pageParams.startDateTime), new Date(this.pageParams.endDateTime)])||''
                    }

                }
            },
        },
        beforeRouteEnter (route, from, next) {
            const { query } = route
            if (JSON.stringify(query) !== '{}') {
                next(vm => {
                    vm.initParams()
                    vm.handleFetchPage()
                })
            }
            next()
        }
    }
</script>

<style lang="scss" scoped>
    /deep/ .right-container-bg{
        padding-right: 8px;
    }
    /deep/ .scroll-wrapper{
        padding-right: 4px;
    }
    .option-analysis {
        margin-top: 10px;
    }

    .active {
        color: #1F6EEF;
    }
    .custom-view {}
    .custom-view:hover > span {
        color: #1F6EEF!important;
    }

    .custom-view:hover > span > i {
        color: #1F6EEF!important;
    }


    .asin-select  {
        /deep/ .el-input .el-input__inner{
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            border-right-color: rgba($color: #000000, $alpha: 0)
        }
        /deep/ .el-input .el-input__inner {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
        }
        /deep/ .el-input .el-input__inner{
            &:hover, &:focus{
                border-right-color: #1F6EEF;
            }
        }
        /deep/ .el-input{
            &:hover, &:focus{
                .el-input__inner{
                    border-right-color: #1F6EEF;
                }
            }
        }
        /deep/ .el-input .el-input__inner {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
        }
    }
    .asin-content {
        flex: 1;
        width: 100%;

        &-no-content {
            height: 150px;
            width: 180px;
            position: absolute;
            left: 50%;
            top: 45%;
            text-align: center;
        }
    }
    .el-autocomplete{
       /deep/ .el-input--mini .el-input__inner{
          height: 32px !important;
       }
    }



</style>
